import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { HBox } from '../../../../components/Box';
import { selectInvoice } from '../../../Invoices/selectors';
import { selectAddressTypes } from '../../../Address/selectors';
import env from '../../../../env';
import { AppClientId } from '../../../Shared/constants';
import companyData from './InstallationCompanyData';

const Header = styled.div`
  width: auto;
  margin-bottom: 6px;
  padding: 6px 18px;
  .buyer {
    font-size: 15px;
    gap: 22px;
  }
`;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class SaleAgreementHeaderComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  get logoSrc() {
    let src = '/public/invoice/idw/logo.jpg';
    switch (env.clientId) {
      case AppClientId.AUTOWIENTJES:
        src = '/public/invoice/autowientjes/logo.jpg';
        break;
      case AppClientId.HOOIKAMMER:
        src = '/public/invoice/hooikammer/logo.jpg';

        break;
      case AppClientId.HARRY_NIJBOER:
        src = '/public/invoice/harrynijboer/logo.jpg';
        break;
        case AppClientId.AUTOHUISSALLAND:
        src = '/public/invoice/autohuissalland/logo.jpg';
        break;
    }

    return src;
  }

  renderHeader() {
    return (
      <Header>
        <HBox>
          <div id="indewal-logo" className="logo">
          <img src={this.logoSrc} style={{ height: 50, marginLeft: 40 }} />
          </div>
          <HBox className="buyer" spaceAround>
            <div>
              {companyData.name} <br />
              {companyData.addressLine1}
              <br />
              {companyData.postcodeAndPlace} <br />
            </div>
            <div>
              {companyData.tel} <br />
              {companyData.eMail} <br />
              {companyData.web} <br />
            </div>
            <div>
              <div className="info-item">IBAN: {companyData.IBAN}</div>

              <div className="info-item">BIC: {companyData.BIC}</div>

              <div className="info-item">BTW: {companyData.BTW}</div>

              {companyData.KVK && (
                <>
                  <div className="info-item">KVK: {companyData.KVK}</div>
                </>
              )}
            </div>
          </HBox>
        </HBox>
      </Header>
    );
  }

  render() {
    return this.renderHeader();
  }
}

SaleAgreementHeaderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoice: selectInvoice(ownProps.outgoingInvoiceId),
    addressTypes: selectAddressTypes(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SaleAgreementHeader = compose(withConnect, withRouter)(SaleAgreementHeaderComp);
